import { Drawer, FormControlLabel, styled, Switch } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../styles/MobileMenuDrawer.module.scss";
import { useTranslation } from "react-i18next";
import logo from "../imgs/logo.svg";
import { Link, useLocation } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";

export default function MobileMenuDrawer({
  totalBalanceUsd,
  open,
  toggleDrawer,
  theme,
  toggleTheme,
  account,
  balance,
  margin,
  eurToUsd,
  profit,
  setSnackType,
  handleClick,
  setSnackMessage,
}) {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();
  const [newPassword, setNewPassword] = useState("");

  const ChangePassword = async () => {
    if (!newPassword) {
      setSnackType("error");
      handleClick();
      setSnackMessage(t("PasswordError"));
      return;
    }
    try {
      const id = secureLocalStorage.getItem("user")?.Id;
      const { data } = await axios.post(
        process.env.REACT_APP_test_url + `/api/users/${id}/password`,
        {
          password: newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${secureLocalStorage.getItem("token")}`,
          },
        }
      );
      if (data) {
        setSnackType("success");
        handleClick();
        setSnackMessage(t("PasswordChanged"));
        setNewPassword("");
      }
    } catch (e) {
      console.log(e);
    }
  };
  const MaterialUISwitch = styled(Switch)(() => ({
    width: 76,
    height: 42,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      margin: 1,
      padding: 0,
      transform: "translate(2px,2px)",
      "&.Mui-checked": {
        color: theme === "dark" ? "#FCFCFC" : "#1F2937",
        transform: "translate(36px,2px)",
        "& .MuiSwitch-thumb:before": {
          content: '""',
          position: "absolute",
          width: "100%",
          height: "100%",
          display: "block",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundImage: `url('data:image/svg+xml;utf8,${encodeURIComponent(
            // Используем вашу иконку солнца
            `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12.0002 8.00016C12.0002 10.2093 10.2093 12.0002 8.00016 12.0002C5.79102 12.0002 4.00016 10.2093 4.00016 8.00016C4.00016 5.79102 5.79102 4.00016 8.00016 4.00016C10.2093 4.00016 12.0002 5.79102 12.0002 8.00016Z" fill="${
              theme === "dark" ? "#FCFCFC" : "#1F2937"
            }" /><path fillRule="evenodd" clipRule="evenodd" d="M8.00016 0.833496C8.27631 0.833496 8.50016 1.05735 8.50016 1.3335V2.00016C8.50016 2.27631 8.27631 2.50016 8.00016 2.50016C7.72402 2.50016 7.50016 2.27631 7.50016 2.00016V1.3335C7.50016 1.05735 7.72402 0.833496 8.00016 0.833496ZM2.93257 2.93257C3.12783 2.73731 3.44441 2.73731 3.63968 2.93257L3.90157 3.19446C4.09683 3.38972 4.09683 3.70631 3.90157 3.90157C3.70631 4.09683 3.38972 4.09683 3.19446 3.90157L2.93257 3.63968C2.73731 3.44441 2.73731 3.12783 2.93257 2.93257ZM13.0676 2.93274C13.2628 3.128 13.2628 3.44459 13.0676 3.63985L12.8057 3.90174C12.6104 4.097 12.2938 4.097 12.0986 3.90174C11.9033 3.70648 11.9033 3.3899 12.0986 3.19463L12.3605 2.93274C12.5557 2.73748 12.8723 2.73748 13.0676 2.93274ZM0.833496 8.00016C0.833496 7.72402 1.05735 7.50016 1.3335 7.50016H2.00016C2.27631 7.50016 2.50016 7.72402 2.50016 8.00016C2.50016 8.27631 2.27631 8.50016 2.00016 8.50016H1.3335C1.05735 8.50016 0.833496 8.27631 0.833496 8.00016ZM13.5002 8.00016C13.5002 7.72402 13.724 7.50016 14.0002 7.50016H14.6668C14.943 7.50016 15.1668 7.72402 15.1668 8.00016C15.1668 8.27631 14.943 8.50016 14.6668 8.50016H14.0002C13.724 8.50016 13.5002 8.27631 13.5002 8.00016ZM12.0986 12.0986C12.2938 11.9033 12.6104 11.9033 12.8057 12.0986L13.0676 12.3605C13.2628 12.5557 13.2628 12.8723 13.0676 13.0676C12.8723 13.2628 12.5557 13.2628 12.3605 13.0676L12.0986 12.8057C11.9033 12.6104 11.9033 12.2938 12.0986 12.0986ZM3.90157 12.0988C4.09683 12.294 4.09683 12.6106 3.90157 12.8059L3.63968 13.0678C3.44441 13.263 3.12783 13.263 2.93257 13.0678C2.73731 12.8725 2.73731 12.5559 2.93257 12.3606L3.19446 12.0988C3.38972 11.9035 3.70631 11.9035 3.90157 12.0988ZM8.00016 13.5002C8.27631 13.5002 8.50016 13.724 8.50016 14.0002V14.6668C8.50016 14.943 8.27631 15.1668 8.00016 15.1668C7.72402 15.1668 7.50016 14.943 7.50016 14.6668V14.0002C7.50016 13.724 7.72402 13.5002 8.00016 13.5002Z" fill="${
              theme === "dark" ? "#FCFCFC" : "#1F2937"
            }" /></svg>`
          )}')`,
        },
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: theme === "dark" ? "#131316" : "#F3F4F6",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      backgroundColor: theme === "dark" ? "#1D1D20" : "#FFF",
      width: 36,
      height: 36,
      position: "relative",
      "&:before": {
        content: '""',
        position: "absolute",
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
        display: "block",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundImage: `url('data:image/svg+xml;utf8,${encodeURIComponent(
          // Используем вашу иконку луны
          `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.00016 14.6668C11.6821 14.6668 14.6668 11.6821 14.6668 8.00016C14.6668 7.6917 14.2045 7.64072 14.045 7.90473C13.2861 9.16058 11.9079 10.0002 10.3335 10.0002C7.94026 10.0002 6.00016 8.06006 6.00016 5.66683C6.00016 4.09247 6.83975 2.7142 8.0956 1.95534C8.35961 1.79581 8.30862 1.3335 8.00016 1.3335C4.31826 1.3335 1.3335 4.31826 1.3335 8.00016C1.3335 11.6821 4.31826 14.6668 8.00016 14.6668Z" fill="${
            theme === "dark" ? "#FCFCFC" : "#1F2937"
          }" /></svg>`
        )}')`,
      },
    },
    "& .MuiSwitch-track": {
      opacity: 1,
      backgroundColor: theme === "dark" ? "#131316" : "#F3F4F6",
      borderRadius: 9999,
      position: "relative",
      "&:before, &:after": {
        content: '""',
        position: "absolute",
        width: "16px",
        height: "16px",
        top: "50%",
        transform: "translateY(-50%)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      },
      "&:before": {
        left: "12px", // Позиция иконки луны
        backgroundImage: `url('data:image/svg+xml;utf8,${encodeURIComponent(
          `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.00016 14.6668C11.6821 14.6668 14.6668 11.6821 14.6668 8.00016C14.6668 7.6917 14.2045 7.64072 14.045 7.90473C13.2861 9.16058 11.9079 10.0002 10.3335 10.0002C7.94026 10.0002 6.00016 8.06006 6.00016 5.66683C6.00016 4.09247 6.83975 2.7142 8.0956 1.95534C8.35961 1.79581 8.30862 1.3335 8.00016 1.3335C4.31826 1.3335 1.3335 4.31826 1.3335 8.00016C1.3335 11.6821 4.31826 14.6668 8.00016 14.6668Z" fill="${
            theme === "dark" ? "#51525C" : "#9CA3AF"
          }" /></svg>`
        )}')`,
      },
      "&:after": {
        right: "12px", // Позиция иконки солнца
        backgroundImage: `url('data:image/svg+xml;utf8,${encodeURIComponent(
          `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12.0002 8.00016C12.0002 10.2093 10.2093 12.0002 8.00016 12.0002C5.79102 12.0002 4.00016 10.2093 4.00016 8.00016C4.00016 5.79102 5.79102 4.00016 8.00016 4.00016C10.2093 4.00016 12.0002 5.79102 12.0002 8.00016Z" fill="${
            theme === "dark" ? "#51525C" : "#9CA3AF"
          }" /><path fillRule="evenodd" clipRule="evenodd" d="M8.00016 0.833496C8.27631 0.833496 8.50016 1.05735 8.50016 1.3335V2.00016C8.50016 2.27631 8.27631 2.50016 8.00016 2.50016C7.72402 2.50016 7.50016 2.27631 7.50016 2.00016V1.3335C7.50016 1.05735 7.72402 0.833496 8.00016 0.833496ZM2.93257 2.93257C3.12783 2.73731 3.44441 2.73731 3.63968 2.93257L3.90157 3.19446C4.09683 3.38972 4.09683 3.70631 3.90157 3.90157C3.70631 4.09683 3.38972 4.09683 3.19446 3.90157L2.93257 3.63968C2.73731 3.44441 2.73731 3.12783 2.93257 2.93257ZM13.0676 2.93274C13.2628 3.128 13.2628 3.44459 13.0676 3.63985L12.8057 3.90174C12.6104 4.097 12.2938 4.097 12.0986 3.90174C11.9033 3.70648 11.9033 3.3899 12.0986 3.19463L12.3605 2.93274C12.5557 2.73748 12.8723 2.73748 13.0676 2.93274ZM0.833496 8.00016C0.833496 7.72402 1.05735 7.50016 1.3335 7.50016H2.00016C2.27631 7.50016 2.50016 7.72402 2.50016 8.00016C2.50016 8.27631 2.27631 8.50016 2.00016 8.50016H1.3335C1.05735 8.50016 0.833496 8.27631 0.833496 8.00016ZM13.5002 8.00016C13.5002 7.72402 13.724 7.50016 14.0002 7.50016H14.6668C14.943 7.50016 15.1668 7.72402 15.1668 8.00016C15.1668 8.27631 14.943 8.50016 14.6668 8.50016H14.0002C13.724 8.50016 13.5002 8.27631 13.5002 8.00016ZM12.0986 12.0986C12.2938 11.9033 12.6104 11.9033 12.8057 12.0986L13.0676 12.3605C13.2628 12.5557 13.2628 12.8723 13.0676 13.0676C12.8723 13.2628 12.5557 13.2628 12.3605 13.0676L12.0986 12.8057C11.9033 12.6104 11.9033 12.2938 12.0986 12.0986ZM3.90157 12.0988C4.09683 12.294 4.09683 12.6106 3.90157 12.8059L3.63968 13.0678C3.44441 13.263 3.12783 13.263 2.93257 13.0678C2.73731 12.8725 2.73731 12.5559 2.93257 12.3606L3.19446 12.0988C3.38972 11.9035 3.70631 11.9035 3.90157 12.0988ZM8.00016 13.5002C8.27631 13.5002 8.50016 13.724 8.50016 14.0002V14.6668C8.50016 14.943 8.27631 15.1668 8.00016 15.1668C7.72402 15.1668 7.50016 14.943 7.50016 14.6668V14.0002C7.50016 13.724 7.72402 13.5002 8.00016 13.5002Z" fill="${
            theme === "dark" ? "#51525C" : "#9CA3AF"
          }"/></svg>`
        )}')`,
      },
    },
  }));

  const languages = [
    {
      value: "en",
      label: "English",
      flag: "https://flagcdn.com/w320/us.png",
    },
    {
      value: "de",
      label: "Deutsch",
      flag: "https://flagcdn.com/w320/de.png",
    },
    {
      value: "cs",
      label: "Czech",
      flag: "https://flagcdn.com/w320/cz.png",
    },
    {
      value: "it",
      label: "Italian",
      flag: "https://flagcdn.com/w320/it.png",
    },
    {
      value: "fr",
      label: "French",
      flag: "https://flagcdn.com/w320/fr.png",
    },
    {
      value: "pl",
      label: "Polish",
      flag: "https://flagcdn.com/w320/pl.png",
    },
  ];
  const currentLanguage = i18n.language;

  const toggleLanguage = () => {
    const currentIndex = languages.findIndex(
      (lang) => lang.value === currentLanguage
    );
    const nextIndex = (currentIndex + 1) % languages.length;
    const nextLanguage = languages[nextIndex].value;

    i18n.changeLanguage(nextLanguage);
    secureLocalStorage.setItem("lang", nextLanguage);
  };

  return (
    <Drawer
      open={open}
      anchor={"top"}
      onClose={toggleDrawer(false)}
      PaperProps={{
        className: styles.paper,
      }}
    >
      <div className={styles.account_drawer}>
        <div className={styles.top_drawer}>
          <div className={styles.drawer_header}>
            <div className={styles.logo}>
              <img src={logo} alt="logo" loading="lazy" />
              <h2>{t("Trading Terminal")}</h2>
            </div>
            <span className={styles.close_icon} onClick={toggleDrawer(false)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M12 4.00003L4 12M3.99997 4L11.9999 12"
                  stroke="#FCFCFC"
                  strokeLinecap="round"
                />
              </svg>
            </span>
          </div>
          <div className={styles.drawer_body}>
            <div className={styles.balances}>
              <div className={styles.inside_balance}>
                <p>
                  {account?.AccountCurrency == "EUR" ? "€" : "$"}{" "}
                  {parseFloat(
                    totalBalanceUsd *
                      (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                  )
                    ? Math.trunc(
                        totalBalanceUsd *
                          (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                        * 10
                        ) / 10
                    : 0}
                </p>
                <span>{t("Margin")}</span>
              </div>
              <div className={styles.inside_balance}>
                <p>
                  {account?.AccountCurrency == "EUR" ? "€" : "$"}{" "}
                  {parseFloat(
                    margin * (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                  )
                    ? Math.trunc(
                        margin *
                          (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                          * 10
                        )/10
                    : 0}
                </p>
                <span>{t("Margin")}</span>
              </div>
              <div className={styles.inside_balance}>
                <p>
                  {account?.AccountCurrency == "EUR" ? "€" : "$"}{" "}
                  {Math.trunc(
                    balance * (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                    * 10
                  ) / 10}
                </p>
                <span>{t("Free Margin")}</span>
              </div>
              <div className={styles.inside_balance}>
                <p className={styles.profit}>
                  {Math.trunc(
                    profit * (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                    * 10
                  ) / 10}
                </p>
                <span>{t("Open P/L")}</span>
              </div>
            </div>

            <div className={styles.changePass}>
              <label htmlFor="">{t("Change password")}</label>
              <div className={styles.input}>
                <input
                  placeholder={t("New password")}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <button onClick={ChangePassword}>{t("Change")}</button>
              </div>
            </div>
            {/* <Link onClick={toggleDrawer(false)} className={styles.tradingTerm}>
                            {t('Go to Account')}
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                <ellipse cx="8.50004" cy="3.99992" rx="2.66667" ry="2.66667" stroke="#FCFCFC"/>
                                <ellipse cx="8.50004" cy="11.3334" rx="4.66667" ry="2.66667" stroke="#FCFCFC"/>
                            </svg>
                        </Link> */}
            <div
              className={styles.settings}
              style={{ justifyContent: "center" }}
            >
              <div className={styles.theme}>
                <FormControlLabel
                  sx={{ margin: 0, "& .MuiSwitch-input": { width: "100%" } }}
                  control={<MaterialUISwitch sx={{ m: 0 }} defaultChecked />}
                  checked={theme === "light"}
                  onChange={() =>
                    toggleTheme(theme === "dark" ? "light" : "dark")
                  }
                />
              </div>
              {/* <div className={styles.lang_currency}>
                                <span className={styles.lang} onClick={toggleLanguage}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none">
                                        <g clipPath="url(#clip0_271_1262)">
                                            <path d="M14.6667 8.00016C14.6667 8.87564 14.4942 9.74255 14.1592 10.5514C13.8242 11.3602 13.3331 12.0952 12.7141 12.7142C12.095 13.3333 11.3601 13.8243 10.5512 14.1594C9.7424 14.4944 8.87549 14.6668 8.00001 14.6668C7.12453 14.6668 6.25762 14.4944 5.44879 14.1594C4.63995 13.8243 3.90502 13.3333 3.28596 12.7142C2.66691 12.0952 2.17584 11.3602 1.84081 10.5514C1.50578 9.74255 1.33334 8.87564 1.33334 8.00016C1.33334 7.12468 1.50578 6.25778 1.84081 5.44894C2.17585 4.6401 2.66691 3.90517 3.28597 3.28612C3.90502 2.66706 4.63995 2.176 5.44879 1.84097C6.25763 1.50593 7.12453 1.3335 8.00001 1.3335C8.87549 1.3335 9.7424 1.50593 10.5512 1.84097C11.3601 2.176 12.095 2.66706 12.7141 3.28612C13.3331 3.90518 13.8242 4.6401 14.1592 5.44894C14.4942 6.25778 14.6667 7.12469 14.6667 8.00016L14.6667 8.00016Z" />
                                            <path d="M10.6667 8.00016C10.6667 8.87564 10.5977 9.74255 10.4637 10.5514C10.3297 11.3602 10.1333 12.0952 9.88563 12.7142C9.63801 13.3333 9.34403 13.8243 9.0205 14.1594C8.69696 14.4944 8.3502 14.6668 8.00001 14.6668C7.64982 14.6668 7.30306 14.4944 6.97952 14.1594C6.65599 13.8243 6.36201 13.3333 6.11439 12.7142C5.86677 12.0952 5.67034 11.3602 5.53633 10.5514C5.40232 9.74255 5.33334 8.87564 5.33334 8.00016C5.33334 7.12468 5.40232 6.25778 5.53633 5.44894C5.67034 4.6401 5.86677 3.90517 6.11439 3.28612C6.36202 2.66706 6.65599 2.176 6.97952 1.84097C7.30306 1.50593 7.64982 1.3335 8.00001 1.3335C8.3502 1.3335 8.69696 1.50593 9.0205 1.84097C9.34403 2.176 9.63801 2.66706 9.88563 3.28612C10.1333 3.90518 10.3297 4.6401 10.4637 5.44894C10.5977 6.25778 10.6667 7.12469 10.6667 8.00016L10.6667 8.00016Z" />
                                            <path d="M1.33334 8H14.6667" strokeLinecap="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_271_1262">
                                                <rect width={16} height={16} fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                            </div> */}
            </div>
          </div>
        </div>
        <div className={styles.drawer_footer}>
          <div onClick={toggleDrawer(false)}>{t("Close")}</div>
        </div>
      </div>
    </Drawer>
  );
}
